import { CircularLoader } from "@duosoftbg/nacid-components";
import React, { useEffect } from "react";
import { useState } from "react";
import { QFTableHorizontal } from "./QFTableHorizontal";
import { QFTableVertical } from "./QFTableVertical";
import { eqfLevelNumberV } from "./dataTableQf";

export const QFTables = ({ data }) => {
  const [activeTable, setActiveTable] = useState<"V" | "H">("H");
  const [logicalTableMapH, setLogicalTableMapH] = useState<boolean[][]>(
    Array(3)
      .fill(null)
      .map(() => Array(5).fill(false)),
  );
  const [columnSwitchH, setColumnSwitchH] = useState<boolean[]>(Array(5).fill(false));
  const [rowSwitchH, setRowSwitchH] = useState<boolean[]>([]);

  const [activeLevelV, setActiveLevelV] = useState<number>(eqfLevelNumberV[0]);
  const [hideMainHeaderV, setHideMainHeaderV] = useState<boolean[]>(Array(2).fill(false));
  const [hideSideHeaderV, setHideSideHeaderV] = useState<boolean[]>(Array(2).fill(false));
  const [hideSublevelsV, setHideSubLevelsV] = useState<boolean[]>([]);

  const windowSize = useWindowSize().width;

  const handleTables = (table: "V" | "H") => {
    setActiveTable(table);
  };

  useEffect(() => {
    setRowSwitchH((prev) =>
      prev.map((_, r) => {
        const row = logicalTableMapH[r];
        if (row.every(Boolean)) return true;
        if (!row.includes(true)) return false;
        return prev[r];
      }),
    );
    setColumnSwitchH((prev) =>
      prev.map((_, c) => {
        const columnValues = logicalTableMapH.map((row) => row[c]);
        if (columnValues.every(Boolean)) return true;
        if (!columnValues.includes(true)) return false;
        return prev[c];
      }),
    );
  }, [logicalTableMapH]);

  useEffect(() => {
    if (data?.countriesQF) {
      setRowSwitchH(Array(data.countriesQF.length).fill(false));
      setLogicalTableMapH(Array.from({ length: data.countriesQF.length }, () => Array(5).fill(false)));
      // @ts-ignore
      setActiveTable(windowSize > 1024 ? "H" : "V");
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data]);

  if (data === null) {
    return <CircularLoader mt={20} />;
  }

  return (
    <>
      {data &&
        (activeTable === "H" ? (
          <QFTableHorizontal
            countryData={data}
            handleTables={handleTables}
            setLogicalTableMapH={setLogicalTableMapH}
            setColumnSwitchH={setColumnSwitchH}
            setRowSwitchH={setRowSwitchH}
            logicalTableMapH={logicalTableMapH}
            columnSwitchH={columnSwitchH}
            rowSwitchH={rowSwitchH}
          />
        ) : (
          <QFTableVertical
            countryData={data}
            handleTables={handleTables}
            setActiveLevelV={setActiveLevelV}
            setHideMainHeaderV={setHideMainHeaderV}
            setHideSideHeaderV={setHideSideHeaderV}
            setHideSublevelsV={setHideSubLevelsV}
            activeLevelV={activeLevelV}
            hideMainHeaderV={hideMainHeaderV}
            hideSideHeaderV={hideSideHeaderV}
            hideSublevelsV={hideSublevelsV}
          />
        ))}
    </>
  );
};

const useWindowSize = () => {
  const [size, setSize] = useState({ width: window.innerWidth, height: window.innerHeight });

  useEffect(() => {
    const handleResize = () => {
      setSize({ width: window.innerWidth, height: window.innerHeight });
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return size;
};
